//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Portal.Toolbox',
                {
                    url: '/Toolbox',
                    component: 'toolboxComponent',
                    resolve: {}
                });
        }
    ]);

    app.component('toolboxComponent', {
        templateUrl: 'App.Portal/States/Toolbox/Toolbox.template.html',
        controller: 'ToolboxController',
        bindings: {
            user: "<"
        }
    });

    app.controller('ToolboxController', ToolboxController);

    ToolboxController.$inject = ['_', 'amplitudeService', '$filter', '$mdSidenav', '$q', '$state', 'toolboxFactory', 'userApi'];

    function ToolboxController(_, amplitudeService, $filter, $mdSidenav, $q, $state, toolboxFactory, userApi) {
        var $ctrl = this;

        ng.extend($ctrl, {
            ui: {
                loading: false
            },
            categories: [
            ],
            tags: [],
            filteredList: [],
            favoriteTiles: [],
            featuredTiles: [],
            searchCategories: [],
            searchTags: [],
            searchText: '',
            showFilteredList: false,
        });

        $ctrl.filterTilesFn = function (value, index, array) {
            var catMatch = true;
            if ($ctrl.searchCategories && $ctrl.searchCategories.length > 0) {
                catMatch = $ctrl.searchCategories.some(function (c) {
                    return c.Name.toLowerCase() === value.Category.toLowerCase();
                });
            }

            var tagMatch = true;
            if ($ctrl.searchTags && $ctrl.searchTags.length > 0) {
                tagMatch = $ctrl.searchTags.some(function (t) {
                    return value.Tags.some(function (vt) {
                        return vt.toLowerCase() === t.name.toLowerCase();
                    });
                });
            }
            return catMatch && tagMatch;
        };

        $ctrl.updateToolboxFavorites = function (updateTile) {
            updateTile.loading = true;
            // find out if we removing or adding tool
            var toolIndex = $ctrl.favoriteTiles.findIndex(function (tile) { return tile.Id === updateTile.Id; });
            var tileIndex = $ctrl.tiles.findIndex(function (tile) { return tile.Id === updateTile.Id; });
            var filteredTileIndex = $ctrl.filteredList.findIndex(function (tile) { return tile.Id === updateTile.Id; });

            // temp for caching potential changes incase the post fails
            var tempFavorites = ng.copy($ctrl.favoriteTiles);
            //var tempTiles = ng.copy($ctrl.tiles);

            if (toolIndex === -1) {
                tempFavorites.push(updateTile);
                //tempTiles[tileIndex].IsFavorite = true;
            } else {
                tempFavorites.splice(toolIndex, 1);
                //tempTiles[tileIndex].IsFavorite = false;
            }
            userApi.updateUserToolboxFavorites($ctrl.user.Id, tempFavorites.map(function (t) { return t.Id; }))
                .then(function (response) {
                    if (toolIndex === -1) {
                        // add to favorites
                        $ctrl.favoriteTiles.push(updateTile);
                        $ctrl.tiles[tileIndex].IsFavorite = true;
                    } else {
                        // remove from favorites
                        $ctrl.favoriteTiles.splice(toolIndex, 1);
                        $ctrl.tiles[tileIndex].IsFavorite = false;
                    }
                    // change updatetile favorite boolean in filtered results
                    if ($ctrl.hasFilterCriteria() && filteredTileIndex > -1) {
                        if (toolIndex === -1)
                            $ctrl.filteredList[filteredTileIndex].IsFavorite = true;
                        else
                            $ctrl.filteredList[filteredTileIndex].IsFavorite = false;
                    }
                })
                .catch(function (error) {
                    console.log(error.data);
                })
                .finally(function () {
                    updateTile.loading = false;
                });
        };

        $ctrl.toggleNav = function (navId) {
            $mdSidenav(navId).toggle();
        };

        $ctrl.updateSearchCategories = function (cat) {
            $ctrl.searchCategories = $ctrl.categories.filter(function (c) { return c.Selected; });
            $ctrl.applyFilters();
        };

        $ctrl.updateSearchtags = function (tag) {
            $ctrl.searchTags = $ctrl.tags.filter(function (t) { return t.selected; });
            $ctrl.applyFilters();
        };

        $ctrl.applyFilters = function () {
            $ctrl.showFilteredList = $ctrl.hasFilterCriteria();
            var result = ng.copy($ctrl.tiles);
            result = $filter('filter')(result, $ctrl.searchText);
            result = $filter('filter')(result, $ctrl.filterTilesFn);
            $ctrl.filteredList = result;
        };

        $ctrl.hasFilterCriteria = function () {
            return $ctrl.searchText.length > 0 || $ctrl.searchCategories.length > 0 || $ctrl.searchTags.length > 0;
        };

        $ctrl.clearSearch = function () {
            $ctrl.searchText = '';
            $ctrl.showFilteredList = false;
        };

        $ctrl.$onInit = function () {
            $ctrl.ui.loading = true;
            $ctrl.categories = toolboxFactory.getCategories();
            var promises = [
                toolboxFactory.getUserPermittedTiles(),
                toolboxFactory.getFeaturedTiles(),
                toolboxFactory.getUserFavorites($ctrl.user.Id)
            ];
            $q.all(promises)
                .then(function (responses) {
                    $ctrl.tiles = responses[0];
                    $ctrl.featuredTiles = responses[1];
                    $ctrl.favoriteTiles = responses[2];
                    $ctrl.tags = responses[0].reduce(function (accumulator, currentValue) {
                        accumulator = accumulator.concat(currentValue.Tags)
                            .filter(function (value, index, self) {
                                return self.indexOf(value) === index;
                            });
                        return accumulator;
                    }, []).map(function (t) {
                        var tag = { name: t, selected: false };
                        return tag;
                    });
                })
                .finally(function () {
                    $ctrl.ui.loading = false;
                });
        };
    }
})(window.angular, window.app);